import React, { useState, useRef } from 'react';
import { CircularProgress } from "@mui/material";
import Button from './Button';
import { useContextApi } from '../../../context/ContextApi';
import { XIcon } from '../../../constants/Icons';

const FoundOut = ({ onClose, onFundOut, isBtnLoading }) => {
    const [amount, setAmount] = useState("");
    const [description, setDescription] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [descriptionError, setDescriptionError] = useState("");
    const amountRef = useRef(null);
    const buttonRef = useRef(null);
    const descriptionRef = useRef(null)
    const {useEscapeKey}=useContextApi();
    const handleClose = () => {
        setAmount("");
        setDescription("");
        setErrorMessage("");
        onClose();
    };
    useEscapeKey(handleClose);
    const handleCashOut = (event) => {
        event.preventDefault();
        if (!validateForm()) return;
        onFundOut(amount, description);
    };

    const validateForm = () => {
        if (!amount) {
            setErrorMessage("Amount cannot be empty.");
            amountRef?.current?.focus();
            return false;
        }
        const parsedValue = parseFloat(amount);
        if (isNaN(parsedValue) || parsedValue <= 0) {
            amountRef?.current?.focus();
            setErrorMessage("Enter a valid numeric amount greater than 0.");
            return false;
        }
        const decimalPart = amount.split(".")[1];
        if (decimalPart && decimalPart.length !== 2) {
            amountRef?.current?.focus();
            setErrorMessage("Amount must have exactly two decimal places (e.g., 22.22).");
            return false;
        }
        if (!description.trim()) {
            setDescriptionError("Description is required.");
            descriptionRef?.current?.focus();
             return false;
          }

        setErrorMessage("");
        return true;
    };

    const handleInputChange = (value) => {
        setErrorMessage("");
        setDescriptionError("")
        let inputValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
        const [integerPart, decimalPart] = inputValue.split(".");

        if (decimalPart && decimalPart.length > 2) {
            inputValue = `${integerPart}.${decimalPart.slice(0, 2)}`;
        }

        if (inputValue.match(/^0\d/)) {
            inputValue = inputValue.replace(/^0+/, "") || "0";
        }

        const parsedValue = parseFloat(inputValue) || 0;
        if (!inputValue || parsedValue <= 0) {
            setErrorMessage("Enter a valid amount greater than 0.");
            setAmount(inputValue || "");
        } else {
            setErrorMessage("");
            setAmount(inputValue);
        }
    };

    const handleEnterFocus = (e, nextRef) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (e.target === amountRef.current) {
            if (!validateForm()) return; 
          }
          nextRef?.current?.focus();
        }
      };

      const handlePaymodeKeyDown = (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleCashOut(e);
        }
      };

    return (
        <div>
            <div className="modal-backdrop show"></div>
            <div
                className="modal show"
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
                style={{ display: "block" }}
            >
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title">Fund Out</h6>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="card w-100 radius-10 mb-0 shadow-none">
                                <div className="card-body p-0">
                                    <form className="row g-3">
                                    <div className="col-md-12">
                                            <label className="form-label">
                                                Amount <small className="text-danger">*</small>
                                            </label>
                                            <input
                                                type="text"
                                                autoComplete="off"
                                                autoFocus
                                                className="form-control"
                                                ref={amountRef}
                                                value={amount}
                                                onKeyDown={(e)=>handleEnterFocus(e,descriptionRef)}
                                                onChange={(e) => handleInputChange(e.target.value)}
                                            />
                                            {errorMessage && (
                                                <small className="text-danger">{errorMessage}</small>
                                            )}
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="description" className="form-label">Description<small className="text-danger">*</small></label>
                                            <input
                                                type="text"
                                                autoComplete="off"
                                                maxLength="5000"
                                                ref={descriptionRef}
                                                className="form-control"
                                                value={description}
                                                onKeyDown={(e)=>handlePaymodeKeyDown(e)}
                                                onChange={(e) => {setDescriptionError("");setErrorMessage("");setDescription(e.target.value)}}
                                            />
                                            {descriptionError && (
                                                <small className="text-danger">{descriptionError}</small>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer d-block">
                            <button
                                onClick={handleClose}
                                type="button"
                                data-bs-dismiss="modal"
                                className="btn btn-outline-secondary text-left"
                            >
                                <XIcon/> Cancel
                            </button>

                            {isBtnLoading ? (
                                <button className="btn btn-primary pb-0 text-right" disabled>
                                    <CircularProgress size={22} className="text-white" />
                                </button>
                            ) : (
                                <Button
                                    ref={buttonRef}
                                    text="Remove"
                                    icon="bx bx-check"
                                    bgColor="btn-primary"
                                    textColor="text-white"
                                    className="text-right"
                                    onClick={handleCashOut}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FoundOut;